import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { AbsenceSalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { InfosSalariePourAbsenceDto } from "../../../dto/GenApi.iNotPaie.Dto/InfosSalariePourAbsenceDto";
import { SalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalSuppressionAbsenceImposeeContrat extends Vue {
    nouvelleAbsence: AbsenceSalarieDto | undefined;
    nouvellesAbsences: AbsenceSalarieDto[] = [];
    tupleSalarieAbsence: [SalarieDto, number][] = [];
    salaries: InfosSalariePourAbsenceDto[] = [];
    selectedSalaries: InfosSalariePourAbsenceDto[] = [];
    dataReady = false;
    envoyerEMailSalaries: boolean = false;

    init(nouvelleAbsence: AbsenceSalarieDto) {
        this.nouvelleAbsence = nouvelleAbsence;
        this.envoyerEMailSalaries = false;
        this.fetchData();
    }

    fetchData(): void {
        this.dataReady = false;
        if (this.nouvelleAbsence != undefined && this.nouvelleAbsence.Id != undefined) {
            ServicesFactoryInstance.SalarieService.getSalariesByAbsenceImposee(this.nouvelleAbsence.Id, data => {
                this.salaries = data;
                this.selectedSalaries = this.salaries;
                this.doSort();
                this.dataReady = true;
            });
        }
    }

    doSort(): void {
        this.salaries.sort(function (a, b) {
            if (a.FullName != undefined && b.FullName != undefined) {
                if (a.FullName > b.FullName) {
                    return 1;
                }
                if (a.FullName < b.FullName) {
                    return -1;
                }
            }

            return 0;
        });
    }

    ischecked(idSalarie): boolean {
        const salarie = this.selectedSalaries.filter(x => x.Id == idSalarie)[0];

        return salarie != undefined;
    }

    selectAll(event): void {
        if (event.target.checked) {
            this.selectedSalaries = this.salaries;
        } else {
            this.selectedSalaries = [];
        }
    }

    select($event, salarie: InfosSalariePourAbsenceDto) {
        if ($event.target.checked) {
            this.selectedSalaries.push(salarie);
        } else {
            this.selectedSalaries = this.selectedSalaries.filter(selectedSalarie => selectedSalarie.Id != salarie.Id);
        }
    }

    cancel(): void {
        $("#modalSuppressionAbsenceImposeeContrat").modal("hide");
    }

    save(): void {
        const listIdAbsence = this.selectedSalaries.map(s => s.IdAbsence);

        ServicesFactoryInstance.AbsencesService.annulerAbsenceCollective(listIdAbsence, this.envoyerEMailSalaries, data => {
            if (data.length > 0 && data.length == listIdAbsence.length) {
                NotificationServiceInstance.SendFailed("Aucune absence n'a pu être supprimée");
            } else if (data.length > 0) {
                data.forEach(message => {
                    NotificationServiceInstance.SendFailed(message);
                });
            } else {
                // nécessaire car le navigateur considère ces dates comme des strings, mais ce sont des dates. On met donc tout au même niveau puis on formatte comme souhaité.
                const dateDebut = (new Date(this.nouvelleAbsence!.DateDebut.toString())).toLocaleDateString();
                const dateFin = (new Date(this.nouvelleAbsence!.DateFin.toString())).toLocaleDateString();

                NotificationServiceInstance.SendSuccess(`L'absence collective du ${dateDebut} au ${dateFin} a été supprimée du planning !`);
                this.$emit("enregistrementOk");
            }
        });

        this.cancel();
    }

    public toggleEnvoiEMail(): void {
        this.envoyerEMailSalaries = !this.envoyerEMailSalaries;
    }


}



// WEBPACK FOOTER //
// ./src/components/planningAbsences/modalSuppressionAbsenceImposeeContrat/modalSuppressionAbsenceImposeeContrat.ts